// extracted by mini-css-extract-plugin
var _1 = "Sf6jv";
var _2 = "wgCGo";
export { _1 as "base", _2 as "tabs" }
